import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import HowToRegIcon from "@material-ui/icons/HowToReg";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import PacketAllocationHoAllocationCreate from "./PacketInventoryHoAllocationCreate";
import PacketAllocationCreate from "../PacketInventoryAllocation/PacketAllocationCreate";
import ToastModal from "views/components/ToastModal";
import { packetHOAllocationTableColumns } from "assets/properties/properties";
import { packetSizes } from "assets/properties/properties";

const PacketInventoryHoAllocation = (props) => {
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [templateData, setTemplateData] = useState(["PinCodes"]);
  const [rawData, setRawData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deletePacket, setDeletePacket] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const { classes, featureFlagState } = props;
  const [callInProgress, setCallInProgress] = useState(false);
  const [packetInventoryShow, setPacketInventoryShow] = useState(true);
  const [allocatedPacket, setAllocatedPacket] = useState(true);
  const [dataPacketSize, setDataPacketSize] = useState("");
  const [dataPacketNumberFrom, setDataPacketNumberFrom] = useState("");
  const [dataPacketNumberTo, setDataPacketNumberTo] = useState("");
  const [packetWeight, setPacketWeight] = useState("");
    const [preFixName, setPreFixName]= useState(false);
  const handleHOPacketSUbmit = async () => {
    setPacketInventoryShow(false);
  };

  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PACKET_INVENTORY_MASTER_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  const packetSizeList = typeof featureFlagState?.packetSizesList !== "undefined" ? JSON.parse(featureFlagState?.packetSizesList) : packetSizes;
  const parseIndicatorData = (data) => {
    let reportData = [];
    data.forEach((packet, i) => {
      if(packet?.status !==  "EXHAUSTED"){
        const packetSizeName = packetSizeList?.filter((item)=> item?.code === packet?.size)
      let row = {
        packetSize: packetSizeName?.[0]?.name || packet.size,
        from: `${packet?.prefix ? packet?.prefix : ''}${packet.serialStartNo}`,
        to: `${packet?.prefix ? packet?.prefix : ''}${packet.serialEndNo}`,
        weight: packet.packetWeight,
        action: getIcons(packet.id, packet.size, packet.serialStartNo, packet.serialEndNo , packet.packetWeight, packet?.prefix ),
      };
      reportData.push(row);}
    });
    setSelectedTableData(reportData);
  };
  // icons function calling
  const getIcons = (code, size, packetFrom, packetTo ,weight, packetPreFix) => {
    return (
      <>
        <IconButton
          aria-label="Edit_Packet"
          onClick={() => onClickUpdateData(code)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete_Packet"
          onClick={() => onClickDeleteData(code)}
        >
          <DeleteIcon />
        </IconButton>
        <IconButton
          aria-label="Assigned_Packet"
          onClick={() => onClickAllocate(size, packetFrom, packetTo ,weight, packetPreFix)}
        >
          <HowToRegIcon />
        </IconButton>
      </>
    );
  };
  const onClickUpdateData = (code) => {
    setDeletePacket(code);
    setPacketInventoryShow(false);
  };
  // delete function
  const onClickDeleteData = (id) => {
    setConfirmationModalHeader("Packet");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeletePacket(id);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeletePacket("");
  };

  const onClickAllocate = (size, packetFrom, packetTo ,weight, packetPreFix) => {
    setDataPacketSize(size);
    setAllocatedPacket(false);
    setDataPacketNumberTo(packetTo);
    setDataPacketNumberFrom(packetFrom);
    setPacketWeight(weight);
    setPreFixName(packetPreFix)
  };

  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete Branch
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.PACKET_INVENTORY_MASTER_DELETE + deletePacket,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Packet HO deleted successful", true);
      GetData();
    }
  };

  const onCloseModal = (type) => {
    if (type === "create") {
      toastUpdate("Success", "Packet Successfully Allocated!", true);
    } else {
      toastUpdate("Success", "Packet updated successfully", true);
    }
    GetData();
  };
  // search function calling
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row.size.toLowerCase().includes(val.toLowerCase()) ||
        row.serialStartNo.toString().includes(val) ||
        row.serialEndNo.toString().includes(val)
      );
    });
    parseIndicatorData(filteredData);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };
  return (
    <GridContainer>
      {packetInventoryShow && allocatedPacket ? (
        <>
          <GridItem xs={12} sm={12} md={12}>
            <SubHeader
              label="Packet HO Inventory"
              button1="ADD"
              button1click={handleHOPacketSUbmit}
              onSearchChange={onSearchChange}
              searchLabel="Search For HO Inventory"
              search
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <ColumnGroupingTable
              columns={packetHOAllocationTableColumns}
              rows={selectedTableData}
            />
          </GridItem>
        </>
      ) : (
        <>
          {!packetInventoryShow && (
            <PacketAllocationHoAllocationCreate
              packetAllocationShow={setPacketInventoryShow}
              packetId={deletePacket}
              setPacketId={setDeletePacket}
              classes={classes}
              onClose={onCloseModal}
              rawData={rawData}
            />
          )}
          {!allocatedPacket && (
            <PacketAllocationCreate
              packetAllocationHOShow={setAllocatedPacket}
              classes={classes}
              closeModal={onCloseModal}
              dataPacketSize={dataPacketSize}
              dataPacketNumberTo={dataPacketNumberTo}
              dataPacketNumberFrom={dataPacketNumberFrom}
              packetWeight={packetWeight}
              preFix={preFixName}
            />
          )}
        </>
      )}
         {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

PacketInventoryHoAllocation.propTypes = {
  classes: PropTypes.object,
};

export default PacketInventoryHoAllocation;
